// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__17bij","selected":"Chip_selected__3TTpo"};